import './App.css';
import { Dashboard } from './components/Dashboard';
import { LoginForm } from './components/LoginForm';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { DashboardDetails } from './components/DashboardDetails';
import { useEffect } from 'react';

function App() {

  //@ts-ignore
  window.ScrollToObject = async (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  return (
    <div className="App">
      <Router>
        <DebugHandler />
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/:id" element={<DashboardDetails />} />
          <Route path="/login" element={<LoginForm />} />
          {/* /signup retained as a redirect for any old links/bookmarks */}
          <Route path="/signup" element={<Navigate to="/login" replace />} />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </div>
  );
}

function DebugHandler() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const debugValue = params.get('debug')

    if (debugValue === '1' || debugValue === '0') {
      localStorage.setItem('debug', debugValue)
      params.delete('debug')
      navigate({ pathname: location.pathname, search: params.toString() }, { replace: true })
    }
  }, [location.search, navigate])

  return null
}

export default App;
